export const auth0Config = {
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    clientSecret: process.env.REACT_APP_AUTH0_CLIENT_SECRET,
    redirectUri: process.env.REACT_APP_AUTH0_CALLBACK_URL,
    audience: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/`,
  };